/**
 * Include your custom JavaScript here.
 */
(function ($) {
$.noConflict();
$(document).ready(function (){

       document.addEventListener('userway:init_completed', function (event) {
           window.addEventListener("klaviyoForms", function(e) { 
        if (e.detail.type == 'open') {
            setTimeout(() => {
              let formElement = $(".klaviyo-form[data-testid='klaviyo-form-" + e.detail.formId + "']");
              let overallElement = formElement.parent().parent().parent().parent().parent().parent();
              let closeButton = overallElement.find(".klaviyo-close-form");
              $(closeButton).on("click", function() {
                overallElement.css("display", "none");
              });
          }, 1000);
        }
    });
    });

    // WOW JS Initialize
    wow = new WOW(
        {
            boxClass: 'wow',      // default
            offset: 10,          // default
            mobile: false,       // default
            live: true        // default
        }
    )
    wow.init();
    
  	/* Universal Header Fixed Header. If no Universal header hide #shopify-section-header and change 85 to 0. */
  	$(window).scroll(function() {
      if ($(this).scrollTop() > 25) {
        $('.Search__Inner').addClass('stuck');
      } else {
        $('.Search__Inner').removeClass('stuck');
      }
    });
  
  	$(window).scroll(function() {
	if ($(this).scrollTop() > 85) {
        $('.announcementBarSection').addClass('hidden');
        $('#shopify-section-header').addClass('smaller');
      } else {
        $('.announcementBarSection').removeClass('hidden');
        $('#shopify-section-header').removeClass('smaller');
      }
    });

    /* Change Header size on scroll
    function resizeHeaderOnScroll() {
        const distanceY = window.pageYOffset || document.documentElement.scrollTop,
            shrinkOn = 85,
            headerEl = document.getElementById('shopify-section-header');

        if (distanceY > shrinkOn) {
            headerEl.classList.add("smaller");
            $('#main').css('margin-top', '-10px');
        } else {
            headerEl.classList.remove("smaller");
            $('#main').css('margin-top', '25px');
        }
    }

    window.addEventListener('scroll', resizeHeaderOnScroll);
    */

    /* Show Page Top on scroll */
    function showPageTopOnScroll() {
        const distanceY = window.pageYOffset || document.documentElement.scrollTop,
            showOn = 500

        if (distanceY > showOn) {
            $('#pageTopImage').fadeIn();
        } else {
            $('#pageTopImage').fadeOut();
        }
    }

    window.addEventListener('scroll', showPageTopOnScroll);

    $('.announcementBarSection').css('display', 'block');

    // Character Slider
    $('.characterSlider').slick({
        draggable: false,
        slidesToShow: 6,
        slidesToScroll: 6,
        arrows: true,
        speed: 1200,
        responsive: [
            {
                breakpoint: 2250,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 5,
                    infinite: true,
                    dots: false,
                    swipe: false
                }
            },
            {
                breakpoint: 1900,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                }
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 720,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            }
        ]
    });

    // Home Hero Slider
    $('.customSlider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: true,
        adaptiveHeight: true,
        dots: true,
        arrows: false,
        infinite: true,
        speed: 700,
        fade: true,
        cssEase: 'linear'
    });

    //Announcement Bar Slider
    $('.announcementBar').slick({
        arrows: true,
        loop: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000
    });

    $(window).on('load resize', function () {

        /* Banner Top Margin */
        let headerHeight = $('#section-header').outerHeight();
        let announcementHeight = $('.announcementBarSection').outerHeight();
        $('.PageContainer').css('margin-top', headerHeight + announcementHeight - 15);

        if ($(window).width() > 960) {
            /* Character Hover State */
            $(".character").hover(function () {
                $(this).find(".characterHover").css("visibility", "visible");
                $(this).find(".characterMain").css("visibility", "hidden");
            }, function () {
                $(this).find(".characterHover").css("visibility", "hidden");
                $(this).find(".characterMain").css("visibility", "visible");
            });

            /* Character Names */
            $('#character1').hover(function () {
                $('.characterNames:nth-child(2)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(2)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character2').hover(function () {
                $('.characterNames:nth-child(3)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(3)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character3').hover(function () {
                $('.characterNames:nth-child(4)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(4)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character4').hover(function () {
                $('.characterNames:nth-child(5)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(5)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character5').hover(function () {
                $('.characterNames:nth-child(6)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(6)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character6').hover(function () {
                $('.characterNames:nth-child(7)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(7)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character7').hover(function () {
                $('.characterNames:nth-child(8)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(8)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character8').hover(function () {
                $('.characterNames:nth-child(9)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(9)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character9').hover(function () {
                $('.characterNames:nth-child(10)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(10)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character10').hover(function () {
                $('.characterNames:nth-child(11)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(11)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character11').hover(function () {
                $('.characterNames:nth-child(12)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(12)').hide();
                $('.characterNames:nth-child(1)').show();
            });

            $('#character12').hover(function () {
                $('.characterNames:nth-child(13)').show();
                $('.characterNames:nth-child(1)').hide();
            }, function () {
                $('.characterNames:nth-child(13)').hide();
                $('.characterNames:nth-child(1)').show();
            });
        } // end of window size

    });

    /* Layered Navigation */
    $('#mobile-filter-trigger-button').on('click', function () {
        $('.drawer--left').addClass('drawer--is-open');
        $('.grid__item.medium-up--one-fifth.grid__item--sidebar').addClass('z-index');
    });

    $('#close-filter-drawer').on('click', function () {
        $('.drawer--left').removeClass('drawer--is-open');
        $('.grid__item.medium-up--one-fifth.grid__item--sidebar').removeClass('z-index');
    });

    /* Sub-Navigation Pages */
    $( ".subNavigationMobile" ).accordion({ 
        collapsible: true,
        active: false,
        heightStyle: "content"
    });

    $('#mobile-sub-navigation-button').click(function (){
        $('.subNavigationMobile').toggle('slide', { direction: 'up' });
    });

    /* Make Nav Link Blank */
    $('a[href^="http"]').not('a[href^="Watch Full Episodes"]').attr('target', '_blank');

    /* Hide Swatches if only one */
    if ($(".ColorSwatchList li, .ProductItem__ColorSwatchList div").length <= 1){
        $(".ColorSwatchList, .ColorSwatchList li:first-child, .ProductItem__ColorSwatchList").hide();
    }

    /* NSFW Button */
    $('#ageTermsCheck').change(function () {
        $('#submit_birthdate').prop("disabled", !this.checked);
    });

    $('#ageTermsCheck').click(function () {
        if ($(this).is(':checked')){
            $("#submit_birthdate").css('opacity', 1);
        } else {
            $("#submit_birthdate").css('opacity', 0.1);
        }
    });

    // Personalize Button
    $("label.ColorSwatch").on("click", function(event){
        setTimeout(function(){
          let allSKUs = $(".ProductMeta__SkuNumber").text();
          let currentSKU = allSKUs.split(" ")[0];
          $("#personalizeButton").data("sku", currentSKU);
        }, 100);  
    });

    // Size Chart
    function sizeChartPopup(){
        // Sizing Chart Popup
        $('.size-chart-button').click(function (){
            $('.size-chart-overlay').fadeIn(500);
            $('.size-chart-popup').fadeIn(500);
            $('body').addClass('locked');
        });
        $('.size-chart-close-button, .size-chart-overlay').click(function (){
            $('.size-chart-overlay').fadeOut(300);
            $('.size-chart-popup').fadeOut(300);
            $('body').removeClass('locked');
        });
    }

    sizeChartPopup();

    // Rerun Scripts in Shopify Theme Editor
    if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function() {
            sizeChartPopup();
        });
    }

});

})(jQuery);